// import Vue from 'vue'
import Request from './Request'

window.baseURL = '/openapi'
// window.baseURL = ''

const request = new Request({
  baseURL: window.baseURL,
  timeout: 60 * 1000,
})

const loginOutRequest = new Request({
  baseURL: '',
  timeout: 60 * 1000,
})

window.API = {
  httpPost: request.httpPost.bind(request),
  httpPostMultiForm: request.httpPostMultiForm.bind(request),
  httpPostJson: request.httpPostJson.bind(request),
  httpGet: request.httpGet.bind(request),
}

window.LoginOutAPI = {
  httpPost: loginOutRequest.httpPost.bind(loginOutRequest),
  httpPostMultiForm: loginOutRequest.httpPostMultiForm.bind(loginOutRequest),
  httpPostJson: loginOutRequest.httpPostJson.bind(loginOutRequest),
  httpGet: loginOutRequest.httpGet.bind(loginOutRequest),
}

// Vue.prototype.$httpPost = request.httpPost.bind(request)
// Vue.prototype.$httpPostJson = request.httpPostJson.bind(request)
// Vue.prototype.$httpGet = request.httpGet.bind(request)
